<template>
  <div>
    <button
      class="add-list"
      :class="{ 'add-list--added': inList }"
      @click="addToList"
    >
      <span v-html="icon"></span>
      <span>{{ inList ? 'Già in lista' : 'Aggiungi alla lista' }}</span>
    </button>

    <transition name="add-toast">
      <div v-if="toastVisible" class="add-list-toast" role="status">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        Prodotto aggiunto alla lista
      </div>
    </transition>
  </div>
</template>

<script>
const STORAGE_KEY = 'ideaerre_wishlist';

export default {
  name: 'AddToList',
  props: {
    product: { type: Object, required: true },
    icon: { type: String, default: '' },
  },
  data() {
    return {
      items: [],
      toastVisible: false,
      toastTimer: null,
    };
  },
  computed: {
    inList() {
      return this.items.some(p => p.id === this.product.id);
    },
  },
  mounted() {
    this.items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  },
  methods: {
    addToList() {
      if (this.inList) return;
      this.items = [...this.items, this.product];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
      this.showToast();
    },
    showToast() {
      clearTimeout(this.toastTimer);
      this.toastVisible = true;
      this.toastTimer = setTimeout(() => { this.toastVisible = false; }, 3000);
    },
  },
};
</script>

<style scoped>
.add-list-toast {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  background: #272C62;
  color: #F5F3EF;
  font-family: "DMSans", sans-serif;
  font-size: 0.9375rem;
  padding: 14px 24px;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(39, 44, 98, 0.25);
  z-index: 2000;
  white-space: nowrap;
}
.add-list-toast svg {
  width: 20px;
  height: 20px;
  fill: #C1AA8C;
  flex-shrink: 0;
}

.add-toast-enter-active,
.add-toast-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.add-toast-enter-from,
.add-toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}
</style>
